import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'shc-about',
  templateUrl: './about.page.html',
  styleUrls: ['./about.page.scss'],
})
export class AboutPage implements OnInit {
  about: string;
  constructor(
    private generalService: GeneralService,
    private errorService: ErrorHandlerService
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {

  }

  getPageContent() {
    this.generalService.showLoader();
    this.generalService.getPageContent({ type: 'about' }).pipe(
      finalize(() => this.generalService.hideLoader())
    ).subscribe(res => {
      this.about = res.content;
    }, error => {
      this.errorService.handle(error);
    });
  }

}
